/**
 * @generated SignedSource<<62481a055cad3f6cad2345c667c6ecbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductMembersList__membersDirectoryFiltersQuery$variables = {
  id: string;
};
export type ProductMembersList__membersDirectoryFiltersQuery$data = {
  readonly app: {
    readonly membersDirectoryFilters?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly memberGroupId: string;
        };
      }>;
    };
  } | null;
};
export type ProductMembersList__membersDirectoryFiltersQuery = {
  response: ProductMembersList__membersDirectoryFiltersQuery$data;
  variables: ProductMembersList__membersDirectoryFiltersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AppDirectoryItemNodeConnection",
      "kind": "LinkedField",
      "name": "membersDirectoryFilters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AppDirectoryItemNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AppDirectoryItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberGroupId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductMembersList__membersDirectoryFiltersQuery",
    "selections": [
      {
        "alias": "app",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductMembersList__membersDirectoryFiltersQuery",
    "selections": [
      {
        "alias": "app",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc88a8e0a0bbf50c60116a7b551d3a7e",
    "id": null,
    "metadata": {},
    "name": "ProductMembersList__membersDirectoryFiltersQuery",
    "operationKind": "query",
    "text": "query ProductMembersList__membersDirectoryFiltersQuery(\n  $id: ID!\n) {\n  app: node(id: $id) {\n    __typename\n    ... on ProductApp {\n      membersDirectoryFilters {\n        edges {\n          node {\n            id\n            memberGroupId\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1e7a4bd2b4c509fc6dc27f894a1b2e3";

export default node;
